export default __webpack_public_path__ + "static/media/resize.cf30b7fd.svg";